import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';
import DashboardHomePage from './DashboardHomePage';
import LandingPage from './LandingPage';

/**
 * `/` : landing publique si non connecté ;
 * modules (DashboardHomePage) si connecté + cabinet actif ;
 * sinon redirection vers sélection de cabinet.
 */
export default function RootEntry() {
  const { isAuthenticated, loading, activeCabinet } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          background: '#0b0d0c',
          color: '#9aa3a0',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}
      >
        Chargement…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LandingPage />;
  }

  if (!activeCabinet) {
    return <Navigate to="/cabinets" replace />;
  }

  return (
    <div className="cgm-page-frame cgm-page-frame--home">
      <Header />
      <div className="cgm-home-page-content">
        <DashboardHomePage />
      </div>
    </div>
  );
}
